import { socket } from '../socket'

// The room of the workspace of the open project. Rooms do not survive a
// reconnect, so the join is repeated on every `connect`.
let current: { workspaceId: string; rejoin: () => void } | null = null

export const joinWorkspace = (workspaceId: string) => {
  leaveWorkspace()

  const rejoin = () => {
    socket.emit('workspace:join', workspaceId)
  }

  current = { workspaceId, rejoin }

  socket.on('connect', rejoin)

  if (socket.connected) {
    rejoin()
  }
}

export const leaveWorkspace = () => {
  if (!current) {
    return
  }

  socket.off('connect', current.rejoin)

  if (socket.connected) {
    socket.emit('workspace:leave', current.workspaceId)
  }

  current = null
}
